


function isValid2(rut) {
  // Eliminar puntos y guión, y convertir a mayúsculas si existe un dígito verificador 'k'
  rut = rut.replace(/[.-]/g, '').toUpperCase();
  // Validar formato del RUT
  if (!/^\d{7,8}[0-9k]$/i.test(rut)) {
    return false;
  }

  // Separar cuerpo y dígito verificador
  const body = rut.slice(0, -1);
  const dv = rut.slice(-1);

  // Calcular dígito verificador esperado
  let sum = 0;
  let multiplier = 2;

  for (let i = body.length - 1; i >= 0; i--) {
    sum += parseInt(body.charAt(i)) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }

  const expectedDV = 11 - (sum % 11);
  const calculatedDV = expectedDV === 11 ? '0' : expectedDV === 10 ? 'K' : String(expectedDV);

  // Comparar dígito verificador calculado con el proporcionado

  return dv === calculatedDV;
}




function isValid(rut, body, dv) {
  console.log("body")
  console.log(body)
  console.log("rut")
  console.log(rut)
  let dvSum = 0;
  let multiple = 2;
  for (let i = 1; i <= body.length; i += 1) {
    const index = multiple * rut.charAt(body.length - i);
    dvSum += index;
    if (multiple < 7) {
      multiple += 1;
    } else {
      multiple = 2;
    }
  }
  const dvExpected = 11 - (dvSum % 11);

  if (dvExpected === parseInt(dv, 10)) {
    return true;
  }
  if (dvExpected === 10 && dv === 'K') {
    return true;
  }
  return dvExpected === 11 && dv === '0';
}

export function sanitizeRut(rut) {
  return rut.replace(/[^\dk]/gi, '')
}

export function formatForBackend(rut) {
  return rut.replace(/\./g, '')
}

function internalFormatRut(rawRut) {
  const sanitizedRut = sanitizeRut(rawRut);
  const body = sanitizedRut.slice(0, -1);
  const dv = sanitizedRut.slice(-1).toUpperCase();
  const formatted = `${body.replace(
    /(?!^)(\d{3})(?=(?:\d{3})*$)/g,
    '.$1',
  )}-${dv}`;
  return { sanitizedRut, body, dv, formatted }
}

export function formatRut(rawRut) {
  if (!rawRut) {
    return ''
  }
  return internalFormatRut(rawRut).formatted;
}

export function validateRut(rawRut) {
  if (!rawRut) {
    return { formatted: '', isValid: false, formattedForBackend: '' };
  }
  const { sanitizedRut, body, dv, formatted } = internalFormatRut(rawRut)
  return {
    formatted,
    isValid: isValid2(sanitizedRut),
    formattedForBackend: formatForBackend(formatted),
  };
}
